var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',_vm._b({staticClass:"kpb-button"},'ButtonComponent',{ ..._vm.data },false))
}
var staticRenderFns = []

export { render, staticRenderFns }